// extracted by mini-css-extract-plugin
export default {"imageContainer":"Pca-z","summaryPar":"Qca-z","ratingCategories":"Rca-z","reviewerInfo":"Sca-z","reviewTypes":"Tca-z","expanded":"Uca-z"};